<template>
	<div class="flex flex-wrap items-center bg-green-100 p-2 text-green-600">
		<i-gg-check-o class="mr-2 size-4" />
		<slot />
	</div>
</template>
